import app from 'flarum/forum/app';
// The API's maximum page: the photos come in pages this big.
const PAGE_SIZE = 500;
/**
 * Every photo of an exhibition's species list as shown (searched, sorted -
 * not only the rows scrolled to: the findings with photos, loaded for it
 * once for each list), one after the other in champis-forum's lightbox, the
 * one every post photo opens in: from the first, or from the photo clicked.
 * Each captioned with its number, species and vernacular name. Without
 * that lightbox, nothing: the photo's own link opens it. The public page's
 * (ExpoPage) and the exhibition's own (ExhibitionPage).
 */
export default class FindingsSlideshow {
  loading = false;

  // The findings with photos, for the list (its version) they were loaded for.
  loaded = null;
  constructor(list,
  // A finding's species as captioned - its own words for an undetermined one.
  name) {
    this.list = list;
    this.name = name;
  }
  open(e, from, photo) {
    const Lightbox = window.flarum.reg.get('champis-forum', 'forum/components/PostImageLightbox');
    if (!Lightbox) return;
    e?.preventDefault();
    if (this.loading) return;
    this.loading = true;
    m.redraw();
    this.findings().then(findings => {
      const images = [];
      let index = 0;
      for (const finding of findings) {
        const name = this.name(finding);
        const caption = [finding.label(), name, finding.vernacularName()].filter(Boolean).join(' · ');
        for (const each of finding.photos() || []) {
          if (finding === from && each.url === photo?.url) index = images.length;
          images.push({
            url: each.url,
            alt: name,
            caption
          });
        }
      }
      if (images.length) app.modal.show(Lightbox, {
        images,
        index
      });
    }).catch(() => app.alerts.show({
      type: 'error'
    }, app.translator.trans('champis-exhibitions.forum.expo_page.slideshow_error'))).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }

  // The list's findings with photos, every page of them.
  async findings() {
    const version = this.list.version;
    if (this.loaded?.version === version) return this.loaded.findings;
    const params = this.list.currentParams;
    const findings = [];
    for (;;) {
      const results = await app.store.find('champis-exhibitions-findings', {
        ...params,
        filter: {
          ...params.filter,
          hasPhotos: 1
        },
        page: {
          offset: findings.length,
          limit: PAGE_SIZE
        }
      }, undefined,
      // Its own message, in open().
      {
        errorHandler: () => {}
      });
      findings.push(...results);
      if (!results.payload.links?.next || results.length === 0) break;
    }
    this.loaded = {
      version,
      findings
    };
    return findings;
  }
}
flarum.reg.add('champis-exhibitions', 'forum/utils/FindingsSlideshow', FindingsSlideshow);